import React from "react";
import { NavLink } from "react-router-dom";
import { Home, BookOpen, Heart, Users, PlayCircle } from "lucide-react";

const items = [
  { to: "/", label: "Acasă", icon: Home },
  { to: "/articole", label: "Articole", icon: BookOpen },
  { to: "/video", label: "Video", icon: PlayCircle },
  { to: "/ajutor", label: "Ajutor", icon: Heart },
  { to: "/comunitate", label: "Povești", icon: Users },
];

export const MobileBottomNav = () => (
  <nav data-testid="mobile-bottom-nav" className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0A1020]/95 backdrop-blur-xl border-t border-white/10">
    <div className="grid grid-cols-5">
      {items.map(i => {
        const Icon = i.icon;
        return (
          <NavLink
            key={i.to}
            to={i.to}
            data-testid={`bottom-nav-${i.to.replaceAll("/", "-")}`}
            end={i.to === "/"}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-2.5 text-[10px] tracking-wide ${
                isActive ? "text-[#D4A63D]" : "text-[#A0AABF]"
              }`
            }
          >
            <Icon className="w-5 h-5" />
            <span className="truncate max-w-full px-1">{i.label}</span>
          </NavLink>
        );
      })}
    </div>
  </nav>
);
